import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useWorkspace } from "../contexts/WorkspaceContext";

export function AppShell() {
  const { logout, identity } = useAuth();
  const { shops, activeShop, meta } = useWorkspace();
  const navigate = useNavigate();

  function switchShop(shopId: string) {
    navigate(`/shops/${shopId}/overview`);
  }

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <a className="brand" href="/">
          <span>T</span>illFlo
        </a>

        <label className="shop-select-label" htmlFor="shop-select">
          Reporting for
        </label>
        <select
          id="shop-select"
          value={activeShop?.id.toText() ?? ""}
          onChange={(event) => switchShop(event.target.value)}
          aria-label="Select shop"
        >
          {shops.map((shop) => (
            <option key={shop.id.toText()} value={shop.id.toText()}>
              {shop.name}
            </option>
          ))}
        </select>

        <nav aria-label="Reports">
          <NavLink to={`/shops/${activeShop?.id.toText()}/overview`}>
            <span className="nav-mark" aria-hidden="true">⌁</span>
            Overview
          </NavLink>
          <NavLink to={`/shops/${activeShop?.id.toText()}/daily`}>
            <span className="nav-mark" aria-hidden="true">≡</span>
            Daily detail
          </NavLink>
        </nav>

        <div className="sidebar-foot">
          <p>{meta?.accountNumber}</p>
          <p className="principal" title={identity?.getPrincipal().toText()}>
            {identity?.getPrincipal().toText()}
          </p>
          <button
            className="text-button"
            onClick={() => void logout()}
            type="button"
          >
            Sign out
          </button>
        </div>
      </aside>
      <main className="workspace">
        <header className="mobile-head">
          <a className="brand" href="/">
            <span>T</span>illFlo
          </a>
          <select
            value={activeShop?.id.toText() ?? ""}
            onChange={(event) => switchShop(event.target.value)}
            aria-label="Select shop"
          >
            {shops.map((shop) => (
              <option key={shop.id.toText()} value={shop.id.toText()}>
                {shop.name}
              </option>
            ))}
          </select>
        </header>
        <Outlet />
      </main>
    </div>
  );
}
